import React, { FC } from "react";
import { CSSProperties } from "styled-components";
import { genderExpressionFEToString } from "../../../../../constants/types/acf";
import { useAssessmentState } from "../../../../../services/assessment-state";
import { Screens } from "../../../../../services/assessment-state/types";
import { AssessmentCopy } from "../../utils";
import { Response } from "./Response";
import { Outer, Inner, Title } from "./styled";

export const YourAnswers: FC<{ style?: CSSProperties }> = ({ style }) => {
    const { state, goToScreen } = useAssessmentState();
    const isForSelf = state.target === "MYSELF";

    return (
        <Outer style={style}>
            <Title>Your answers</Title>
            <Inner>
                <Response
                    question={AssessmentCopy.WHO_FOR}
                    response={isForSelf ? "Myself" : "Someone else"}
                    onEdit={() => {
                        goToScreen(Screens.WhoFor);
                    }}
                />
                <Response
                    question={AssessmentCopy.AGE_QUESTION[isForSelf ? "SELF" : "CARER"]}
                    response={state.age + " years old"}
                    onEdit={() => {
                        goToScreen(Screens.Age);
                    }}
                />
                <Response
                    question={AssessmentCopy.GENDER_QUESTION[isForSelf ? "SELF" : "CARER"]}
                    response={genderExpressionFEToString(state.gender_identity) ?? ""}
                    onEdit={() => {
                        goToScreen(Screens.GenderExpression);
                    }}
                />
                <Response
                    question={AssessmentCopy.ABOUT[isForSelf ? "SELF" : "CARER"]}
                    response="Edit Answers"
                    onEdit={() => {
                        goToScreen(Screens.About);
                    }}
                />
                <Response
                    question={AssessmentCopy.DISORD_CONCERN[isForSelf ? "SELF" : "CARER"]}
                    response="Edit Answers"
                    onEdit={() => {
                        goToScreen(Screens.SupportRequirements);
                    }}
                />
            </Inner>
        </Outer>
    );
};
